import React, { createContext, FunctionComponent, useReducer } from 'react';
import { IClaimState } from 'types/claim';
import claimReducer, { initialState } from './ClaimReducer';
export const ClaimContext = createContext<IClaimState | any>(initialState);

export const ClaimProvider: FunctionComponent = (props): JSX.Element => {
  const [state, dispatch] = useReducer(claimReducer, initialState);

  return (
    <ClaimContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </ClaimContext.Provider>
  );
};
